import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { EMPTY, filter, from, switchMap, tap } from 'rxjs';
import {
  SwUpdate,
  VersionEvent,
  VersionReadyEvent,
} from '@angular/service-worker';
import { ResourceService } from '@global/infrastructure/abstracts/resource/resource.service';
import { Environment } from '@global/infrastructure/models/environment';
import { environment } from '@env/environment';

@Injectable({
  providedIn: 'root',
})
export class ServiceWorkerService extends ResourceService<any> {
  constructor(
    private readonly swUpdate: SwUpdate,
    httpClient: HttpClient,
    env: Environment
  ) {
    super(httpClient, env, 'log');
  }

  appUpdateCheck() {
    if (this.swUpdate.isEnabled !== true) return EMPTY;
    return from(this.swUpdate.checkForUpdate());
  }

  appApplyUpdate() {
    if (this.swUpdate.isEnabled !== true) return EMPTY;
    return this.swUpdate.versionUpdates.pipe(
      filter(
        (evt: VersionEvent): evt is VersionReadyEvent =>
          evt.type === 'VERSION_READY'
      ),
      switchMap((s) =>
        this.create({
          message: `${environment.brand_copy.brand} app refreshing.`,
        }).pipe(tap(() => window.location.reload()))
      )
    );
  }
}
